<section class="page-hero" [ngClass]="heroClass">
  <div class="page-title-block">
    <div class="page-eyebrow">
      <mat-icon>{{ icon }}</mat-icon>
      <span>{{ eyebrow }}</span>
    </div>
    <h1>{{ title }}</h1>
    <p>{{ subtitle }}</p>
  </div>

  <div class="page-hero-actions">
    <!-- <div class="hero-stat-card">
      <span class="hero-stat-label">Resultados</span>
      <strong>{{ resultCount }}</strong>
    </div> -->
    <div class="hero-stat-card muted">
      <span class="hero-stat-label">Filtros activos</span>
      <strong>{{ activeFilterCount }}</strong>
    </div>
    <button
      type="button"
      mat-raised-button
      class="btn-hero-refresh"
      (click)="refresh.emit()"
      [disabled]="isLoading"
    >
      <mat-icon>refresh</mat-icon>
      Actualizar
    </button>
  </div>
</section>
